// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZXEWy","footer":"styles_footer__Hv7T2"};